import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timeout = null
  }

  save() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 500)
  }

  saveNow() {
    clearTimeout(this.timeout)
    this.element.requestSubmit()
  }

  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.saveNow()
    }
  }
}
